// Package Imports

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width="25"
    height="25"
    fill="none"
    stroke="currentColor"
    strokeWidth="4.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="13" y="21" width="74" height="66" rx="7" />
    <path d="M13 39H87 M30 12V28 M70 12V28" />
    <g fill="currentColor" stroke="none">
      <rect x="25" y="46" width="6" height="6" rx="1" />
      <rect x="40" y="46" width="6" height="6" rx="1" />
      <rect x="55" y="46" width="6" height="6" rx="1" />
      <rect x="70" y="46" width="6" height="6" rx="1" />
      <rect x="25" y="60" width="6" height="6" rx="1" />
      <rect x="40" y="60" width="6" height="6" rx="1" />
      <rect x="55" y="60" width="6" height="6" rx="1" />
      <rect x="25" y="74" width="6" height="6" rx="1" />
      <rect x="40" y="74" width="6" height="6" rx="1" />
    </g>
    <circle cx="68" cy="68" r="21" fill="white" />
    <circle cx="68" cy="68" r="21" />
    <circle cx="68" cy="55" r="4" />
    <path d="M68 59C68 69 58 70 60 77C62 84 74 82 74 74" />
  </svg>
);

const HookEventResource: ResourceItem = {
  name: resourceName.hookEvent,
  identifier: ModuleIdentifierConst.HOOK_EVENT,
  list: `${resourceName.hookEvent}`,
  create: `${resourceName.hookEvent}/create`,
  edit: `${resourceName.hookEvent}/edit/:id`,
  show: `${resourceName.hookEvent}/show/:id`,
  options: { label: 'Hook Event', icon },
  meta: {
    label: 'Hook',
    icon,
    parent: resourceName.hook,
  },
};

export default HookEventResource;
